import { render, staticRenderFns } from "./AdditionalLinks.vue?vue&type=template&id=6a800a02&lang=pug&"
import script from "./AdditionalLinks.vue?vue&type=script&lang=js&"
export * from "./AdditionalLinks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports